import { type FromUrlSearchParams } from "~/Search/utils/historyManipulation";
import { BreadcrumbType } from "~/utils/models";

export function filterUnavailableParams(params: FromUrlSearchParams): FromUrlSearchParams {
  if (window.SCHA.config.isZoovuEnabled) {
    return params;
  }
  return {
    ...params,
    breadcrumbs: params.breadcrumbs.filter((bc) => {
      if (bc.type === BreadcrumbType.TECH_VALUE) {
        return true;
      }
      return window.SCHA.config.validSearchSuffixes.includes(bc.facetCode);
    }),
  };
}
